module.exports = __webpack_public_path__ + "img/GAME_AIRPLANE.4ea01182.png";